<template>
  <div class="argic-info">
    <div class="argic-info-header">
      <p>农机信息</p>
    </div>
    <div class="argic-info-content">
      <div class="info-item" v-for="(item, key) in agricInfo" :key="key">
        <div class="info-item-label">{{ item.id }}：</div>
        <div class="info-item-value">{{ item.name || "--" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    agricInfo: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.argic-info {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(85, 84, 127, 0.12);
  border-radius: 15px;
  padding: 10px 27px;
  margin-bottom: 65px;
  &-header {
    font-size: 14px;
    line-height: 24px;
    color: #11d8a0;
    border-bottom: 1px dashed #ecf4ff;
    padding-bottom: 12px;
  }
  &-content {
    padding-top: 10px;
    .info-item {
      margin-bottom: 12px;
      font-size: 14px;
      line-height: 24px;
      display: flex;
      justify-content: space-between;
      &-label {
        color: #999999;
      }
      &-value {
        color: #333333;
      }
    }
  }
}
</style>
